// {{BASE_URL}}
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import { varToStringParams } from 'utils/path';

export enum StoreStatus {
  Active = 1,
  Disabled = 2,
  Deleted = 3,
}
/** getStoreUrl  */
export interface IStoreUrlOutput extends Types.ResponseOutput {
  data: {
    id: number;
    name: string;
    url: string;
    sslenabled: boolean;
    hosts: string;
    defaultlanguageid: number;
    displayorder: number;
    companyname: string;
    companyaddress: string;
    companyphonenumber: string;
    companyvat: null | string;
    settings: {
      'cellock.theme.navigationType'?: string;
      'cellock.theme.palleteId'?: string;
      'cellock.theme.logoId'?: string;
      'cellock.theme.title'?: string;
      'cellock.theme.backgroundImage'?: string;
      'cellock.theme.darkMode'?: 'True' | 'False';
      // 'cellock.template.home'?: string;
      'cellock.homepage.facebook'?: string;
      'cellock.homepage.linkedin'?: string;
      'cellock.homepage.twitter'?: string;
      'cellock.homepage.youtube'?: string;
      'cellock.homepage.googleBusiness'?: string;
      'cellock.homepage.instagram'?: string;
      'cellock.address'?: string;
      'cellock.metadata.title'?: string;
      'cellock.metadata.keywords'?: string;
      'cellock.metadata.description'?: string;
      'cellock.general.blog'?: string;
      'cellock.general.news'?: string;
      'cellock.general.newsletter'?: string;
      'cellock.general.shop'?: string;
      'cellock.map.apikey'?: string;
      'cellock.map.mapLoadApikey'?: string;
      'cellock.business_info.business_keywords'?: string;
      'cellock.business_info.business_lincence_no'?: string;
      'cellock.business_info.business_name'?: string;
      'cellock.business_info.business_registration_no'?: string;
      'cellock.business_info.business_tagline'?: string;
      'cellock.contact_details.contact_address'?: string;
      'cellock.contact_details.contact_area'?: string;
      'cellock.contact_details.contact_city'?: string;
      'cellock.contact_details.contact_country'?: string;
      'cellock.contact_details.contact_email'?: string;
      'cellock.contact_details.contact_fax'?: string;
      'cellock.contact_details.contact_mobile'?: string;
      'cellock.contact_details.contact_postcode'?: string;
      'cellock.contact_details.contact_telephone'?: string;
    };
  };
}

export const getStoreUrl = async (): Promise<IStoreUrlOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/store/url`
  );

  return data;
};

export interface IUpdateStoreInput {
  id: number;
  name: string | null;
  url: string | null;
  sslenabled: boolean | null;
  status: number | null;
  hosts: string | null;
  defaultlanguageid: number | null;
  displayorder: number | null;
  companyname: string | null;
  companyaddress: string | null;
  companyphonenumber: string | null;
  companyvat: string | null;
}
export interface IStoresListInput {
  sortField?: string;
  page?: number;
  pageSize?: number;
  order?: 'asc' | 'desc';
  language?: string;
  name?: string;
}

export interface IPaging {
  page: number;
  pageSize: number;
  total: number;
}

export interface IDataItems {
  id: number;
  name: string | null;
  url: string | null;
  sslenabled: boolean;
  hosts: string | null;
  defaultlanguageid: number;
  displayorder: number;
  companyname: string | null;
  companyaddress: string | null;
  companyphonenumber: string | null;
  companyvat: string | null;
  status: number | null;
  datecreated: string | null;
}

export interface IStoresListOutput {
  items: IDataItems[];
  paging: IPaging;
}
export interface IInsertStoresInput {
  name: string | null;
  url: string | null;
  companyname: string | null;
  companyaddress: string | null;
  companyphonenumber: string | null;
  companyvat: string | null;
}

export const fetchStoresList = async (
  payload: IStoresListInput
): Promise<Types.ResponseOutput> => {
  let query = varToStringParams({
    variablesArray: [
      { key: 'page', value: payload.page?.toString() },
      { key: 'pageSize', value: payload.pageSize?.toString() },
      { key: 'sortField', value: payload.sortField },
      { key: 'order', value: payload?.order?.toUpperCase() },
      { key: 'name', value: payload?.name },
    ],
  });

  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/store/list${query}`
  );

  let _data: IStoresListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const insertStores = async (
  payload: IInsertStoresInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/store`,
    {
      body: payload,
    }
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const deleteStores = async (
  id: number | null
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'delete',
    `${Environment.API_BASE_URL}/api/store/${id}`
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const fetchOneStore = async (payload: {
  id: number;
}): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/store/${payload.id}`
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const updateStore = async (
  payload: IUpdateStoreInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/store/${payload.id}`,
    {
      body: payload,
    }
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
